import { PlanProductDetailsResponse, SoldProductDetailsResponse } from '../../../../../hooks';
import { PlanProductItemRankedAreaSalesMarket } from '../sales.util';
import { transformSoldProductDataWithRanking } from '../topSoldProductWidget/util';

export const getWeeklyTop20PlanProductsData = (
  planResponseData: PlanProductDetailsResponse,
  soldResponseData: SoldProductDetailsResponse,
  filterIndex?: string,
): PlanProductItemRankedAreaSalesMarket[] => {
  const soldProductsRankedVsAreaVsSalesMarket = transformSoldProductDataWithRanking(soldResponseData, filterIndex);

  let planProducts = [...planResponseData];

  if (filterIndex) {
    planProducts = planProducts.filter((item) => item.indexId === filterIndex);
  }

  // Map sorted products with sold products ranking data
  const products: PlanProductItemRankedAreaSalesMarket[] = planProducts.map((storeProductItem) => {
    const {
      productId,
      productName,
      departmentNumber,
      departmentName,
      subIndexId,
      subIndexDescription,
      price,
      planSales,
      articleId,
    } = storeProductItem;

    const soldProductItem = soldProductsRankedVsAreaVsSalesMarket.find((sold) => sold.productId === productId);

    return {
      productId,
      productName,
      departmentNumber,
      departmentName,
      subIndexId,
      subIndexDescription,
      price,
      planSales,
      articleIdentifier: articleId,
      rankingVsArea: soldProductItem?.rankingVsArea ?? 0,
      rankingVsSalesMarket: soldProductItem?.rankingVsSalesMarket ?? 0,
      differenceLastLastWeek: soldProductItem?.differenceLastLastWeek ?? 0,
      soldPieces: soldProductItem?.soldPieces ?? 0,
      netSale: soldProductItem?.netSale ?? 0,
    };
  });

  // Filter out the plan products which have net sale as 0
  const planProductsWithoutZeroNetSale = products.filter((soldProduct) => soldProduct.netSale !== 0);

  // Sort plan products by plan sales in descending order
  const sortedItems = planProductsWithoutZeroNetSale.sort((a, b) => b.planSales - a.planSales);

  // Get top 20 products based on plan sales
  const top20Products = sortedItems.slice(0, 20);

  return top20Products;
};
